import { useEffect, useState } from 'react';

// The tagline reads as one sentence, but it carries two separate promises.
// Rotating them one at a time gives each its own moment instead of burying the
// second half at the tail of a run-on line.
const PHRASES = [
  { text: 'Accurate Prayer Times', accent: 'text-yellow-700' },
  { text: 'Praying For Western Muslims', accent: 'text-red-500' },
];

// The full sentence, kept intact for screen readers and for anyone who has
// asked their system to stop animations.
const SENTENCE = 'Accurate Prayer Times, And Praying For Western Muslims.';

// Must stay in step with the .tagline-phrase / .tagline-rule animations.
const HOLD_MS = 3200;

// Reserving the widest phrase keeps the header from reflowing on every swap.
const WIDEST = PHRASES.reduce((a, b) => (b.text.length > a.text.length ? b : a)).text;

const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

function motionIsMuted() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia(REDUCED_MOTION).matches;
}

function AnimatedTagline() {
  const [index, setIndex] = useState(0);
  const [muted, setMuted] = useState(motionIsMuted);

  // Follow the setting live — someone may flip it while the tab is open.
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const query = window.matchMedia(REDUCED_MOTION);
    const sync = () => setMuted(query.matches);
    query.addEventListener('change', sync);
    return () => query.removeEventListener('change', sync);
  }, []);

  useEffect(() => {
    if (muted) return undefined;
    const timer = setInterval(
      () => setIndex((n) => (n + 1) % PHRASES.length),
      HOLD_MS,
    );
    return () => clearInterval(timer);
  }, [muted]);

  if (muted) {
    return <p className="text-sm text-gray-600">{SENTENCE}</p>;
  }

  const phrase = PHRASES[index];

  return (
    <p className="tagline text-sm text-gray-600">
      <span className="sr-only">{SENTENCE}</span>
      <span className="tagline-window" aria-hidden="true">
        <span className="tagline-sizer">{WIDEST}</span>
        {/* the key remounts the span so the slide replays on every swap */}
        <span key={index} className={`tagline-phrase font-semibold ${phrase.accent}`}>
          {phrase.text}
        </span>
      </span>
      <span className="tagline-rule" aria-hidden="true" />
    </p>
  );
}

export default AnimatedTagline;
